import { useState, useEffect, useCallback } from "react";
import api from "../services/api";
import DashboardTab       from "./stocks/DashboardTab";
import CatalogTab         from "./stocks/CatalogTab";
import MovementsTab       from "./stocks/MovementsTab";
import ValuationTab       from "./stocks/ValuationTab";
import InventoryTab       from "./stocks/InventoryTab";
import OrdersTab          from "./stocks/OrdersTab";
import PreparationTab     from "./stocks/PreparationTab";
import CustomerOrdersTab  from "./stocks/CustomerOrdersTab";

const TABS = [
  { id: "dashboard",       label: "Tableau de bord",    icon: "📊" },
  { id: "catalog",         label: "Catalogue",           icon: "📦" },
  { id: "movements",       label: "Mouvements",          icon: "🔄" },
  { id: "valuation",       label: "Valorisation FIFO",   icon: "💰" },
  { id: "inventory",       label: "Inventaire",          icon: "📋" },
  { id: "orders",          label: "Commandes achat",     icon: "🛒" },
  { id: "customer-orders", label: "Commandes clients",   icon: "📥" },
  { id: "preparation",     label: "Préparation",         icon: "🚚" },
];

export default function Stocks({ currentCompanyId, companies = [], onNavigate }) {
  const [tab, setTab]                         = useState("dashboard");
  const [products, setProducts]               = useState([]);
  const [suppliers, setSuppliers]             = useState([]);
  const [warehouses, setWarehouses]           = useState([]);
  const [alertCount, setAlertCount]           = useState(0);
  const [orderCount, setOrderCount]           = useState(0);
  const [prepCount, setPrepCount]             = useState(0);
  const [customerOrderCount, setCustomerOrderCount] = useState(0);
  const [openProductModal, setOpenProductModal]     = useState(false);

  const loadShared = useCallback(() => {
    if (!currentCompanyId) return;
    api.stocks.products(currentCompanyId, { limit: 500 })
      .then(r => setProducts(r.products || []))
      .catch(console.error);
    api.stocks.suppliers(currentCompanyId)
      .then(r => setSuppliers(Array.isArray(r) ? r : []))
      .catch(console.error);
    api.stocks.warehouses(currentCompanyId)
      .then(r => setWarehouses(Array.isArray(r) ? r : []))
      .catch(console.error);
    api.stocks.dashboard(currentCompanyId)
      .then(d => { setAlertCount(d.alerts || 0); })
      .catch(console.error);
    api.stocks.orders(currentCompanyId, { status: "sent" })
      .then(r => setOrderCount(Array.isArray(r) ? r.filter(o => o.status === 'sent').length : 0))
      .catch(console.error);
    api.stocks.preparations(currentCompanyId, { status: "to_prepare" })
      .then(r => setPrepCount(Array.isArray(r) ? r.length : 0))
      .catch(console.error);
    api.customerOrders.stats(currentCompanyId)
      .then(s => setCustomerOrderCount((s.pending||0) + (s.validated||0)))
      .catch(console.error);
  }, [currentCompanyId]);

  useEffect(() => { loadShared(); }, [loadShared]);

  if (!currentCompanyId) {
    return (
      <div style={{ textAlign: "center", padding: 80, color: "var(--text-muted)" }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>📦</div>
        <div style={{ fontSize: 16, fontWeight: 600 }}>Sélectionnez une société pour accéder aux stocks</div>
      </div>
    );
  }

  const tabProps = { currentCompanyId, products, suppliers, warehouses, companies, onRefresh: loadShared, onNavigate };

  return (
    <div>
      {/* Header */}
      <div className="page-header" style={{ marginBottom: 0 }}>
        <div>
          <h2 className="page-title" style={{ marginBottom: 2 }}>Gestion des stocks</h2>
          <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
            {products.length} produit(s) · {suppliers.length} fournisseur(s) · {warehouses.length} entrepôt(s)
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {alertCount > 0 && (
            <button onClick={() => setTab("catalog")} style={{ background: "#ba751722", border: "1px solid #ba751733", color: "#ba7517", padding: "6px 12px", borderRadius: 8, cursor: "pointer", fontWeight: 600, fontSize: 12 }}>
              ⚠️ {alertCount} alerte(s)
            </button>
          )}
          {orderCount > 0 && (
            <button onClick={() => setTab("orders")} style={{ background: "#185fa522", border: "1px solid #185fa533", color: "#185fa5", padding: "6px 12px", borderRadius: 8, cursor: "pointer", fontWeight: 600, fontSize: 12 }}>
              🛒 {orderCount} commande(s) en cours
            </button>
          )}
          {prepCount > 0 && (
            <button onClick={() => setTab("preparation")} style={{ background: "#d9770622", border: "1px solid #d9770633", color: "#d97706", padding: "6px 12px", borderRadius: 8, cursor: "pointer", fontWeight: 600, fontSize: 12 }}>
              🚚 {prepCount} préparation(s) à traiter
            </button>
          )}
          {customerOrderCount > 0 && (
            <button onClick={() => setTab("customer-orders")} style={{ background: "#185fa522", border: "1px solid #185fa533", color: "#185fa5", padding: "6px 12px", borderRadius: 8, cursor: "pointer", fontWeight: 600, fontSize: 12 }}>
              📥 {customerOrderCount} commande(s) client à traiter
            </button>
          )}
        </div>
      </div>

      {/* Onglets */}
      <div style={{ display: "flex", gap: 2, borderBottom: "2px solid var(--border-color, #e2e8f0)", marginBottom: 20, marginTop: 16, overflowX: "auto" }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: "9px 16px", fontSize: 13, fontWeight: tab === t.id ? 700 : 500,
            cursor: "pointer", border: "none", background: "transparent",
            color: tab === t.id ? "var(--g)" : "var(--text-muted)",
            borderBottom: `2px solid ${tab === t.id ? "var(--g)" : "transparent"}`,
            marginBottom: -2, whiteSpace: "nowrap", transition: "all 0.12s",
            display: "flex", alignItems: "center", gap: 6,
          }}>
            <span>{t.icon}</span>
            <span>{t.label}</span>
            {t.id === "catalog" && alertCount > 0 && (
              <span style={{ fontSize: 10, background: "#ba7517", color: "#fff", padding: "1px 5px", borderRadius: 8, fontWeight: 700 }}>{alertCount}</span>
            )}
            {t.id === "orders" && orderCount > 0 && (
              <span style={{ fontSize: 10, background: "#185fa5", color: "#fff", padding: "1px 5px", borderRadius: 8, fontWeight: 700 }}>{orderCount}</span>
            )}
            {t.id === "preparation" && prepCount > 0 && (
              <span style={{ fontSize: 10, background: "#d97706", color: "#fff", padding: "1px 5px", borderRadius: 8, fontWeight: 700 }}>{prepCount}</span>
            )}
            {t.id === "customer-orders" && customerOrderCount > 0 && (
              <span style={{ fontSize: 10, background: "#185fa5", color: "#fff", padding: "1px 5px", borderRadius: 8, fontWeight: 700 }}>{customerOrderCount}</span>
            )}
          </button>
        ))}
      </div>

      {/* Contenu de l'onglet actif */}
     {tab === "dashboard" && (
  <DashboardTab
    {...tabProps}
    onNewProduct={() => { setTab("catalog"); setOpenProductModal(true); }}
  />
)}
{tab === "catalog" && (
  <CatalogTab
    {...tabProps}
    openOnMount={openProductModal}
    onMounted={() => setOpenProductModal(false)}
  />
)}
      {tab === "movements"    && <MovementsTab    {...tabProps} />}
      {tab === "valuation"    && <ValuationTab    {...tabProps} />}
      {tab === "inventory"    && <InventoryTab    {...tabProps} />}
      {tab === "orders"          && <OrdersTab          {...tabProps} />}
      {tab === "customer-orders" && <CustomerOrdersTab  {...tabProps} />}
      {tab === "preparation"     && <PreparationTab     {...tabProps} />}
    </div>
  );
}
